export default __webpack_public_path__ + "static/media/notification.88543b03.svg";